<template>
  <!-- <div class="add_pricing_modal" :id="'sideBar'+$store.state.sidebar"> -->
  <div class="add_pricing_modal">
    <widgetModal :title="form.id ? 'Update pricing' : 'Add New Pricing'" subtitle="Pricing information"
      btnlefttext="Cancel" btnrighttext="Save" :leftloading="submit_price_loading" :rightloading="false"
      :footerhidden="false" @onLeftClick="onComfirm" @onRightClick="onClose">
      <div class="widget-modal-body-noscoll">
        <b-field v-if="type == 'events' && event_session && event_session.hasSubEvent == 1"
          label="Select Event Session">
          <b-select v-model="form.event_session_id" expanded placeholder="Select event session">
            <option :value="event_session.id">Whole Event</option>
            <option v-for="subEvent in event_session.subEvents" :key="subEvent.id" :value="subEvent.id">
              {{ getSubEventLabel(subEvent) }}
            </option>
          </b-select>
        </b-field>

        <b-field v-if="type == 'subscription' || type == 'events'"
          :label="type == 'events' ? 'Seat Type' : 'Plan name'">
          <b-input v-model="form.name" :placeholder="type == 'events' ? 'Enter seat type' : 'Enter plan name'"
            :disabled="(form.id && form.boughtTickets > 0)"></b-input>
        </b-field>

        <b-field v-if="type == 'events'" label="Attendees">
          <b-numberinput v-model="form.attendees" expanded min="1" controls-position="compact"></b-numberinput>
        </b-field>

        <b-field v-if="type == 'events'" label="Amount Range Pricing">
          <b-switch v-model="form.amount_range_enabled">
            Enable pricing based on amount range
          </b-switch>
        </b-field>

        <b-field v-if="type == 'events' && form.amount_range_enabled" label="Minimum Amount">
          <div class="row">
            <b-select v-model="form.currency">
              <option value="RWF">RWF</option>
            </b-select>
            <b-numberinput v-model="form.min_amount" expanded min="1" controls-position="compact"></b-numberinput>
          </div>
        </b-field>

        <b-field v-if="type == 'events' && form.amount_range_enabled" label="Maximum Amount">
          <div class="row">
            <b-select v-model="form.currency">
              <option value="RWF">RWF</option>
            </b-select>
            <b-numberinput v-model="form.max_amount" expanded min="1" controls-position="compact"></b-numberinput>
          </div>
        </b-field>

        <b-field v-if="type != 'events' || !form.amount_range_enabled" label="Amount">
          <div class="row">
            <b-select v-model="form.currency">
              <option value="RWF">RWF</option>
              <option v-if="type == 'streaming' || type == 'voting'" value="USD">USD</option>
            </b-select>
            <b-numberinput v-model="form.amount" expanded min="1" controls-position="compact"></b-numberinput>
          </div>
        </b-field>



        <b-field label="Select Location">
          <widgetSelect v-model="form.location" :opt="countries" placeholder="Select location"></widgetSelect>
        </b-field>
        <b-field v-if="type == 'subscription'" label="Time frame (Days)">
          <b-numberinput v-model="form.days" expanded min="1" controls-position="compact"></b-numberinput>
        </b-field>

        <b-field :message="type == 'events' ? '0 is for unlimited' : ''" v-if="type == 'voting' || type == 'events'"
          :label="type == 'voting' ? 'Allowed Votes' : 'Available Seats'">
          <b-numberinput v-model="form.quantity" expanded min="0" controls-position="compact"></b-numberinput>
        </b-field>

        <b-field v-if="type == 'voting' || type == 'events' || type == 'donation'" label="Price Index">
          <b-numberinput v-model="form.item_index" expanded min="1" controls-position="compact"></b-numberinput>
        </b-field>

        <b-field v-if="type == 'events'">
          <template #label>
            Ticket Template
            <b-tooltip type="is-dark">
              <template v-slot:content>
                This is the template that will be used to design the ticket,<br> Use download button to get templete and
                use
                it for your design make sure you don't add any thing on white section, <br> we will use that section for
                QR
                code
              </template>
              <b-icon size="is-small" icon="help-circle-outline"></b-icon> <a
                href="https://cagura-assets.b-cdn.net/assets/uploaded/ck1vd8e9xjuq6i02woobkhi7kbj5hzchy4yxgmhuow8owvj1dwk87e.jpg"
                target="_blank" rel="noopener noreferrer"
                download="https://cagura-assets.b-cdn.net/assets/uploaded/ck1vd8e9xjuq6i02woobkhi7kbj5hzchy4yxgmhuow8owvj1dwk87e.jpg">Download</a>
            </b-tooltip>
          </template>
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.image" @onFileSelected="(file) => {
              form.image = file;
            }
            ">
            <div class="image-upload-widget">
              <p>Choose Image (PNG:2000 X 647)
              </p>
            </div>
          </upload-trigger>
        </b-field>


        <b-field v-if="type == 'events'">
          <template #label>
            Invitation Template
            <b-tooltip type="is-dark">
              <template v-slot:content>
                This is the template that will be used to design the Invitation,<br> Use download button to get templete
                and
                use
                it for your design make sure you don't add any thing on white section, <br> we will use that section for
                QR
                code
              </template>
              <b-icon size="is-small" icon="help-circle-outline"></b-icon> <a
                href="https://cagura-assets.b-cdn.net/assets/uploaded/ck1vd8e9xjuq6i02woobkhi7kbj5hzchy4yxgmhuow8owvj1dwk87e.jpg"
                target="_blank" rel="noopener noreferrer"
                download="https://cagura-assets.b-cdn.net/assets/uploaded/ck1vd8e9xjuq6i02woobkhi7kbj5hzchy4yxgmhuow8owvj1dwk87e.jpg">Download</a>
            </b-tooltip>
          </template>
          <upload-trigger :open="false" :enableinput="false" :required="false" :multiple="false"
            location="assets/uploaded/" :url="$store.state.ASSETS_BASE_URL"
            :uploadurl="$store.state.BASE_URL + 'upload'" name="main-image" :value="form.invitationTemplate"
            @onFileSelected="(file) => {
              form.invitationTemplate = file;
            }
            ">
            <div class="image-upload-widget">
              <p>Choose Image (PNG:2000 X 647)
              </p>
            </div>
          </upload-trigger>
        </b-field>

        <b-field label="Visibility Status" expanded>
          <b-select v-model="form.status" expanded>
            <option value="pending">Pending</option>
            <option value="published">Published</option>
          </b-select>
        </b-field>
      </div>
    </widgetModal>
  </div>
</template>

<script>
import { getSubEventLabel } from "@/helpers/subEvent.js";

export default {
  name: "add_pricing_modal",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "subscription",
    },
    ref_id: {
      type: String,
      default: null,
    },
    event_session: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  data() {
    return {
      submit_price_loading: false,
      form: {
        id: null,
        name: "",
        currency: "RWF",
        amount: 0,
        location: "default",
        location_name: "",
        days: 1,
        status: "pending",
        price_type: "subscription",
        ref_id: null,
        quantity: 1,
        item_index: 0,
        attendees: 1,
        image: "",
        invitationTemplate: "",
        boughtTickets: 0,
        event_session_id: null,
        amount_range_enabled: false,
        min_amount: 0,
        max_amount: 0,
      },
    };
  },
  computed: {
    countries() {
      let vm = this;
      return vm.$store.state.Finance.countries;
    },
  },
  mounted() {
    let vm = this;
    if (vm.content) {
      vm.setFormFields();
    } else {
      vm.resetFormFields();
    }

    if (vm.type == 'events' && vm.event_session && vm.event_session.hasSubEvent != 1) {
      vm.form.event_session_id = vm.event_session.id;
    }
  },
  methods: {
    getSubEventLabel,
    resetFormFields() {
      let vm = this;
      vm.form = {
        id: null,
        name: "",
        currency: "RWF",
        amount: 0,
        location: "default",
        location_name: "",
        days: 1,
        status: "pending",
        price_type: "subscription",
        ref_id: null,
        quantity: 1,
        item_index: 0,
        attendees: 1,
        image: "",
        invitationTemplate: "",
        boughtTickets: 0,
        event_session_id: null,
        amount_range_enabled: false,
        min_amount: 0,
        max_amount: 0,
      };
    },
    setFormFields() {
      let vm = this;
      vm.form = {
        id: vm.content.id,
        name: vm.content.name,
        currency: vm.content.currency,
        amount: vm.content.amount,
        location: vm.content.location,
        location_name: vm.content.location_name,
        days: parseInt(vm.content.days),
        status: vm.content.status,
        price_type: vm.content.type,
        ref_id: vm.content.ref_id,
        quantity: vm.content.quantity,
        item_index: parseInt(vm.content.item_index),
        attendees: parseInt(vm.content.attendees),
        image: vm.content.image,
        invitationTemplate: vm.content.invitationTemplate,
        boughtTickets: vm.content.boughtTickets,
        event_session_id: vm.content.event_session_id || (vm.content.type === 'events' ? vm.event_session.id : (vm.content.type === 'subevents' ? vm.content.ref_id : null)),
        amount_range_enabled: !!vm.content.amount_range_enabled,
        min_amount: parseInt(vm.content.min_amount) || 0,
        max_amount: parseInt(vm.content.max_amount) || 0,
      };
    },
    onComfirm() {
      let vm = this;
      // Start validate
      const rules = {
        name: {
          run: (value) => {
            if (!value && vm.type == "subscription") {
              return "Name can not be empty";
            }
            return false;
          },
        },
        amount: {
          run: (value) => {
            if (vm.type == 'events' && vm.form.amount_range_enabled) {
              return false;
            }
            if (!value) {
              return "Amount can not be empty";
            }
            return false;
          },
        },
        min_amount: {
          run: (value) => {
            if (vm.type == 'events' && vm.form.amount_range_enabled) {
              if (!value) {
                return "Minimum amount can not be empty";
              }
              if (value < 1) {
                return "Minimum amount can not be below 1";
              }
            }
            return false;
          },
        },
        max_amount: {
          run: (value) => {
            if (vm.type == 'events' && vm.form.amount_range_enabled) {
              if (!value) {
                return "Maximum amount can not be empty";
              }
              if (value < vm.form.min_amount) {
                return "Maximum amount must be greater than or equal to minimum amount";
              }
            }
            return false;
          },
        },
        days: {
          run: (value) => {
            if (!value && vm.type == "subscription") {
              return "Days can not be empty";
            }
            if (value < 1 && vm.type == "subscription") {
              return "Days can not be below 1";
            }
            return false;
          },
        },
        location: {
          run: (value) => {
            if (!value) {
              return "Please select location";
            }
            return false;
          },
        },
        event_session_id: {
          run: (value) => {
            if (!value && vm.type == "events" && vm.event_session) {
              return "Please select event session";
            }
            return false;
          },
        },
      };
      if (vm.$isFieldsValidated(vm.form, rules)) {
        vm.submit_price_loading = true;

        if (vm.type === 'events' && vm.form.amount_range_enabled) {
          vm.form.amount = vm.form.min_amount;
        }

        if (vm.type === 'events' && vm.event_session) {
          if (vm.form.event_session_id === vm.event_session.id) {
            vm.form.price_type = 'events';
          } else {
            vm.form.price_type = 'subevents';
          }
        } else {
          vm.form.price_type = vm.type;
        }

        let countryItem = vm.countries.find(
          (item) => item.value == vm.form.location
        );
        vm.form.location_name = countryItem.label;

        // Set ref_id based on event session selection
        if (vm.type === 'events' && vm.event_session) {
          if (vm.form.event_session_id === vm.event_session.id) {
            vm.form.ref_id = vm.ref_id; // Main event ID
          } else {
            vm.form.ref_id = vm.form.event_session_id; // Sub event ID
          }
        } else {
          vm.form.ref_id = vm.ref_id;
        }
        if (!vm.form.id) {
          vm.$store
            .dispatch("PRICING_ADD_PRICING", vm.form)
            .then((response) => {
              vm.submit_price_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.$emit("success");
            })
            .catch(({ response }) => {
              vm.submit_price_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        } else {
          vm.$store
            .dispatch("PRICING_UPDATE_PRICING", vm.form)
            .then((response) => {
              vm.submit_price_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Message",
                text: response.data.message,
              });
              vm.$emit("success");
            })
            .catch(({ response }) => {
              vm.submit_price_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "Message",
                text: response.data.message,
              });
            });
        }
      }
    },
    onClose() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.add_pricing_modal {
  .modal-tabs {
    padding: 10px 15px;
  }

  .overlay {
    left: 230px;

    @media (max-width: 768px) {
      left: 0;
    }
  }
}

#sideBartrue {
  &.widget-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }

    @media (max-width: 500px) {
      width: 100% !important;
      margin: 0;
    }
  }
}
</style>
